export default __webpack_public_path__ + "static/media/okc-chain.21db4554.svg";